import { styled } from '@linaria/react';

import { MqTablet } from '~theme/media';

export const Container = styled.div`
	display: flex;
	width: 100%;
	max-width: 1040px;
	flex-direction: column;
	padding: 0 20px;
	margin: 60px auto;
	gap: var(--gap-x10);

	${MqTablet} {
		padding: 0;
	}

	&:empty {
		display: none;
	}
`;
